import { ComponentType } from 'react';

import { IconProps } from '@crehana/icons/dist/types';
import {
  Accounts,
  Announcement,
  Brain,
  Browser,
  ComboChart,
  DownloadFile,
  Flag,
  Idea,
  LaptopSearch,
  LineChart,
  OnlineShopping,
  PaperAndPen,
  Presentation,
  SchoolChat,
  WebDesign,
} from '@crehana/icons/pictograms';

import { EVENTS } from '@/views/B2BLanding/events';

import { MENU_OPTIONS } from './Header.models';

export type subItemType = {
  id: number;
  key: string;
  name: string;
  description: string;
  link: string;
  icon: ComponentType<React.PropsWithChildren<IconProps>>;
};

export type subCategoryType = {
  id: string;
  title: string;
  subItems: subItemType[];
};

export type itemDataType = {
  groups?: subCategoryType[];
  items?: subItemType[];
  link?: string;
};

type itemType = {
  id: number;
  name: string;
  type: 'items' | 'groups' | 'link';
  data: itemDataType;
};

export type DataType = {
  [key in MENU_OPTIONS]: itemType;
};

export const DATA: DataType = {
  [MENU_OPTIONS.PRODUCT]: {
    id: 1,
    name: 'HEADER_ID_1_NAME',
    type: 'items',
    data: {
      items: [
        {
          id: 1.1,
          name: 'HEADER_ID_1_ITEM_1_NAME',
          key: EVENTS.MAIN_HEADER_PRODUCT_DETAIL_SKILL_IQ_TEST,
          description: 'HEADER_ID_1_ITEM_1_DESCRIPTION',
          link: '/business/productos/skill-xp/',
          icon: LineChart,
        },
        {
          id: 1.2,
          name: 'HEADER_ID_1_ITEM_2_NAME',
          key: EVENTS.MAIN_HEADER_PRODUCT_DETAIL_DEVELOPMENT,
          description: 'HEADER_ID_1_ITEM_2_DESCRIPTION',
          link: '/business/productos/mentorias/',
          icon: SchoolChat,
        },
        {
          id: 1.3,
          name: 'HEADER_ID_1_ITEM_3_NAME',
          key: EVENTS.MAIN_HEADER_PRODUCT_DETAIL_CLASSROOMS,
          description: 'HEADER_ID_1_ITEM_3_DESCRIPTION',
          link: '/business/productos/classrooms/',
          icon: PaperAndPen,
        },
        {
          id: 1.4,
          name: 'HEADER_ID_1_ITEM_4_NAME',
          key: EVENTS.MAIN_HEADER_PRODUCT_DETAIL_DATA_ANALYSIS,
          description: 'HEADER_ID_1_ITEM_4_DESCRIPTION',
          link: '/business/productos/analisis-de-data/',
          icon: ComboChart,
        },
      ],
    },
  },
  [MENU_OPTIONS.PRICING]: {
    id: 4,
    name: 'HEADER_ID_4_NAME',
    type: 'link',
    data: {
      link: '/business/precios/',
    },
  },
  [MENU_OPTIONS.RESOURCES]: {
    id: 3,
    name: 'HEADER_ID_3_NAME',
    type: 'items',
    data: {
      items: [
        {
          id: 3.1,
          name: 'HEADER_ID_3_ITEM_1_NAME',
          key: EVENTS.MAIN_HEADER_RESOURCES_BLOG,
          description: 'HEADER_ID_3_ITEM_1_DESCRIPTION',
          link: 'https://www.crehana.com/blog/empresas/',
          icon: Browser,
        },
        {
          id: 3.2,
          name: 'HEADER_ID_3_ITEM_2_NAME',
          key: EVENTS.MAIN_HEADER_RESOURCES_DOWNLOADABLES,
          description: 'HEADER_ID_3_ITEM_2_DESCRIPTION',
          link: '/business/descargables/',
          icon: DownloadFile,
        },
      ],
    },
  },
  [MENU_OPTIONS.TRACKS]: {
    id: 2,
    name: 'HEADER_ID_2_NAME',
    type: 'groups',
    data: {
      groups: [
        {
          id: 'academies',
          title: 'HEADER_ID_2_GROUP_1_TITLE',
          subItems: [
            {
              id: 2.5,
              name: 'HEADER_ID_2_GROUP_1_SUBITEM_1_NAME',
              key: EVENTS.MAIN_HEADER_TRACK_DETAIL_LEADERSHIP,
              description: 'HEADER_ID_2_GROUP_1_SUBITEM_1_DESCRIPTION',
              link: '/business/academias/academia-de-liderazgo/',
              icon: Flag,
            },
            {
              id: 2.2,
              name: 'HEADER_ID_2_GROUP_1_SUBITEM_2_NAME',
              key: EVENTS.MAIN_HEADER_TRACK_DETAIL_INNOVATION,
              description: 'HEADER_ID_2_GROUP_1_SUBITEM_2_DESCRIPTION',
              link: '/business/academias/academia-de-innovacion/',
              icon: Idea,
            },
            {
              id: 2.7,
              name: 'HEADER_ID_2_GROUP_1_SUBITEM_3_NAME',
              key: EVENTS.MAIN_HEADER_TRACK_DETAIL_DIGITAL_MARKETING,
              description: 'HEADER_ID_2_GROUP_1_SUBITEM_3_DESCRIPTION',
              link: '/business/academias/academia-de-marketing-digital/',
              icon: Announcement,
            },
            {
              id: 2.1,
              name: 'HEADER_ID_2_GROUP_1_SUBITEM_4_NAME',
              key: EVENTS.MAIN_HEADER_TRACK_DETAIL_SALES,
              description: 'HEADER_ID_2_GROUP_1_SUBITEM_4_DESCRIPTION',
              link: '/business/academias/academia-de-ventas/',
              icon: Presentation,
            },
          ],
        },
        {
          id: 'learningPath',
          title: 'HEADER_ID_2_GROUP_2_TITLE',
          subItems: [
            {
              id: 2.3,
              name: 'HEADER_ID_2_GROUP_2_SUBITEM_1_NAME',
              key: EVENTS.MAIN_HEADER_TRACK_DETAIL_DIGITAL_MINDSET,
              description: 'HEADER_ID_2_GROUP_2_SUBITEM_1_DESCRIPTION',
              link: '/business/tracks/digital-mindset/',
              icon: Brain,
            },
            {
              id: 2.4,
              name: 'HEADER_ID_2_GROUP_2_SUBITEM_2_NAME',
              key: EVENTS.MAIN_HEADER_TRACK_DETAIL_DATA_ANALYSIS,
              description: 'HEADER_ID_2_GROUP_2_SUBITEM_2_DESCRIPTION',
              link: '/business/tracks/analisis-de-data/',
              icon: LaptopSearch,
            },
            {
              id: 2.6,
              name: 'HEADER_ID_2_GROUP_2_SUBITEM_3_NAME',
              key: EVENTS.MAIN_HEADER_TRACK_DETAIL_ECOMMERCE,
              description: 'HEADER_ID_2_GROUP_2_SUBITEM_3_DESCRIPTION',
              link: '/business/tracks/e-commerce/',
              icon: OnlineShopping,
            },
            {
              id: 2.8,
              name: 'HEADER_ID_2_GROUP_2_SUBITEM_4_NAME',
              key: EVENTS.MAIN_HEADER_TRACK_DETAIL_UXUI,
              description: 'HEADER_ID_2_GROUP_2_SUBITEM_4_DESCRIPTION',
              link: '/business/tracks/ui-ux/',
              icon: WebDesign,
            },
          ],
        },
      ],
    },
  },

  [MENU_OPTIONS.PARTNERS]: {
    id: 0,
    name: 'HEADER_ID_0_NAME',
    type: 'items',
    data: {
      items: [
        {
          id: 0.1,
          name: 'HEADER_ID_0_ITEM_1_NAME',
          key: EVENTS.MAIN_HEADER_PARTNERS_PARTNERSHIPS,
          description: 'HEADER_ID_0_ITEM_1_DESCRIPTION',
          link: '/business/partnerships/',
          icon: Announcement,
        },
        {
          id: 0.2,
          name: 'HEADER_ID_0_ITEM_2_NAME',
          key: EVENTS.MAIN_HEADER_PARTNERS_REFERRALS,
          description: 'HEADER_ID_0_ITEM_2_DESCRIPTION',
          link: '/business/referrals/',
          icon: Accounts,
        },
      ],
    },
  },
};
